export default {
    delete_billing_account_title: 'Eliminar Cuenta de Facturación',
    delete_billing_account_descrption: '¿Estás seguro de que deseas eliminar esta cuenta de facturación? Esta acción no se puede deshacer.',
    delete_billing_account_successfully_delete: 'La cuenta de facturación se eliminó correctamente',
    delete_billing_account_error_delete: 'Ocurrió un error al eliminar la cuenta de facturación',
    delete_billing_account_new_billing_account: 'Nueva Cuenta de Facturación',
    delete_billing_account_new_billing_account_message: '* Puedes seleccionar una nueva cuenta de facturación para asignar los disopsitivos de la cuenta de facturación que estás eliminando',
};